import { useEffect } from 'react';
import { evalJavaScript } from 'js/utils/DOM.util';
import { tagTypeService } from 'js/services/tagType.service';
import { TAG_TYPE } from 'js/components/system/TagManager/constants';

export const CustomJs = ({ config, tagName }) => {
    const { code } = config;

    useEffect(() => {
        evalJavaScript({
            code,
            context: `tagName::${tagName}`
        });
    }, [code, tagName]);

    return null;
};

tagTypeService.registerTagType({ [TAG_TYPE.customJs]: CustomJs });
